import { useEffect, useState } from "react";

import React from "react";
import Slider from "react-slick";
import Lightbox from 'react-image-lightbox';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlickCarousel = (props) => {
    const publicUrl = process.env.PUBLIC_URL;
    const [nav1, setNav1] = useState(Object);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slider1, setSlider1] = useState(Object);

    useEffect(() => {
      setNav1(slider1);
    }, [slider1]);

    const settings = {
        onReInit: () => setCurrentSlide(slider1?.innerSlider.state.currentSlide),
        lazyLoad: true,
        asNavFor: ".slider-nav",
        focusOnSelect: true,
        dots: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true
    };

    const handleClickImage = (e, image) => {
      e.preventDefault();
   
      setCurrentSlide(publicUrl + image);
     }
   
     const handleCloseModal = (e) => {
      e && e.preventDefault();
      //setCurrentSlide()
      
     }
    
      return (
        <>
            <Slider {...settings}
                asNavFor={nav1}
                ref={(slider) => setSlider1(slider)}
            >
              {props.sliderSource.map((item) => (
                <div key={item.id}>
                  <div className="img-body">
                    <img src={item.src} alt={item.alt} onClick={ e => handleClickImage(e, item.src)} />
                  </div>
                  <div>
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </Slider>
            <div className="thumb-wrapper">
              {props.sliderSource.map((item, idx) => (
                <div
                  key={idx}
                  className={currentSlide === idx ? "active": null}
                  onClick={() => {
                    slider1?.slickGoTo(idx)
                  }}>
                  <img src={item.src} alt={item.alt}/>
                  {currentSlide}
                </div>
              ))}
            </div>
            {/* {currentSlide &&
                <Lightbox
                    mainSrc={currentSlide}
                    onCloseRequest={handleCloseModal}
                    />
              } */}
        </>
      );
}

export default SlickCarousel;